import { useEffect, useState } from 'react'

/**
 * Cuenta regresiva del throttling (429) de los endpoints de kit.
 *
 * El backend limita por IP tanto `/auth/kit/login` (PIN) como
 * `/auth/kit/verify` (código del kit) y devuelve `retry_after_s`; la UI
 * bloquea la entrada mientras corre el contador. Es el mismo mecanismo en
 * las tres pantallas (`KitPinScreen`, `PlayerLogin`, `KitCodeForm`), así que
 * el tick vive acá una sola vez.
 */

/** Espera por defecto cuando el 429 no trae `retry_after_s`. */
export const FALLBACK_LOCKOUT_S = 60

export function useLockoutCountdown() {
  const [lockedFor, setLockedFor] = useState(0)
  const locked = lockedFor > 0

  useEffect(() => {
    if (lockedFor <= 0) return
    const t = setInterval(() => setLockedFor((s) => Math.max(0, s - 1)), 1000)
    return () => clearInterval(t)
    // Sólo importa el flanco "arrancó / terminó": el intervalo se re-crea
    // cuando el lockout empieza o llega a cero, no en cada segundo.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockedFor > 0])

  return { lockedFor, locked, startLockout: setLockedFor }
}
